import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;

  & > div:first-child {
    border-right: solid 1px ${p => p.theme.colors.grisOscuro};
    padding-right: ${p => p.theme.space[4]}px;
    margin-right: ${p => p.theme.space[4]}px;
  }
`;

const Half = styled.div`
  flex: 1 1;
  text-align: center;
`;

const Title = styled.div`
  text-align: center;

  @media all and (min-width: ${p => p.theme.breakpoints[0]}px) {
    text-align: left;
  }
`

const Monto = styled.div`
  color: ${p => p.theme.colors.negro};
  font-size: 20px;
  text-align: center;
`

const Moneda = styled.div`
  color: ${p => p.theme.colors.grisOscuro};
  font-size: 12px;
  text-align: center;
`

export default ({ tasas: rawTasas }) => {
  const tasas = [
    {
      titulo: "preferencial",
      montos: [
        {
          moneda: "Colones",
          monto: rawTasas.preferencialColones
        },
        {
          moneda: "Dólares",
          monto: rawTasas.preferencialDolares
        }
      ]
    },
    {
      titulo: "normal",
      montos: [
        {
          moneda: "Colones",
          monto: rawTasas.normalColones
        },
        {
          moneda: "Dólares",
          monto: rawTasas.normalDolares
        }
      ]
    }
  ];
  return (
    <Container>
      {tasas.map(tasa => (
        <div key={tasa.titulo}>
          <Title>Tasa {tasa.titulo} mensual</Title>
          <div style={{ display: `flex` }}>
            {tasa.montos.map((monto, i) => (
              <Half key={monto.moneda}>
                <Moneda>{monto.moneda}</Moneda>
                <Monto>{monto.monto}%</Monto>
              </Half>
            ))}
          </div>
        </div>
      ))}
    </Container>
  );
};
